import React, { Component } from 'react';
import { Modal, Form, FormGroup, ControlLabel, FormControl, HelpBlock, ButtonToolbar, Button } from 'react-bootstrap';
import DatePicker from 'react-16-bootstrap-date-picker';

export class EditionEditSingleIntervalForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            originalEndDate: this.props.value.endDate
        };
    }

    getButtonText(operation) {
        if ("publish" === operation) {
            return "PUBLICAR";
        }

        if("archive" === operation) {
            return "ARQUIVAR";
        }

        return "GUARDAR ALTERAÇÕES";
    }

    renderHelpBlock(inputError, message) {
        if (null === inputError) {
            return null;
        }

        return (<HelpBlock>{message}</HelpBlock>);
    }

    renderNameFormControl(operation, value) {
        if ("publish" === operation || "archive" === operation) {
            return <p>{value.name}</p>;
        }

        return (
            <FormControl
                type="text"
                value={value.name}
                placeholder="Introduza o Nome"
                onChange={(a) => this.props.onChangeValue(a, "name")}
            />
        );
    }

    renderStartDateFormControl(operation, value) {
        if ("archive" === operation) {
            return <p>{value.startDate}</p>;
        }

        return (
            <DatePicker
                id="editionStartDatePicker"
                dateFormat="DD/MM/YYYY"
                value={value.startDate}
                placeholder="DD/MM/YYYY"
                onChange={(a) => this.props.onChangeDateValue(a, "startDate")} />
        );
    }

    renderEndDateFormControl(operation, value) {
        const { originalEndDate } = this.state;

        if ("archive" === operation && undefined !== originalEndDate) {
            return <p>{value.endDate}</p>;
        }

        return (
            <DatePicker
                id="editionEndDatePicker"
                dateFormat="DD/MM/YYYY"
                value={value.endDate}
                placeholder="DD/MM/YYYY"
                onChange={(a) => this.props.onChangeDateValue(a, "endDate")} />
        );
    }

    render() {
        const { value, operation, nameInputError, startDateInputError, endDateInputError,
            nameErrorMessage, startDateErrorMessage, endDateErrorMessage } = this.props;

        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>Editar</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <FormGroup controlId="formName" validationState={nameInputError} >
                            <ControlLabel>Nome</ControlLabel>
                            {this.renderNameFormControl(operation, value)}
                            {this.renderHelpBlock(nameInputError, nameErrorMessage)}
                        </FormGroup>

                        <FormGroup controlId="formStartDate" validationState={startDateInputError} >
                            <ControlLabel>Data Início</ControlLabel>
                            {this.renderStartDateFormControl(operation, value)}
                            {this.renderHelpBlock(startDateInputError, startDateErrorMessage)}
                        </FormGroup>

                        <FormGroup controlId="formEndDate" validationState={endDateInputError} >
                            <ControlLabel>Data Fim</ControlLabel>
                            {this.renderEndDateFormControl(operation, value)}
                            {this.renderHelpBlock(endDateInputError, endDateErrorMessage)}
                        </FormGroup>
                    </Form>
                    <ButtonToolbar>
                        <Button onClick={this.props.onSave}> {this.getButtonText(operation)} </Button>
                        <Button onClick={this.props.onHide}> CANCELAR </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/editions/forms/EditionEditSingleIntervalForm.js